import Vue from 'vue';
import msToast from './MsToast.vue';

const ToastConstructor = Vue.extend(msToast);

let instance;

export default {
	name: 'toast',
	msfunction(parameters) {
		if (parameters.fullWidth) {
			if (parameters.position) {
				parameters.position = parameters.position.replace(
					'right',
					'left'
				);
			}
		}

		instance = new ToastConstructor({
			data: parameters
		});
		instance.vm = instance.$mount();
		parameters.click ? instance.vm.$on('click', parameters.click) : null;
		document.body.insertBefore(instance.vm.$el, document.body.firstChild);
	}
};
